module.exports = __webpack_public_path__ + "static/media/klimaatlas_berichterstattung_220125.8073854b.mp4";